import {Deserializable} from "./deserializable.model";

export class BillingTask {

    billing_task_id: number;
    billing_task_name: string;
    myob_tax_code_id: number;
    myob_account_code_id: number;
    billing_task_description: string;
    brand_type_id: number;
    job_type_id: number;
    billing_task_fee: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): BillingTask {
    Object.assign(this, input);

    return this;
  }

  /*
billing_task_id
billing_task_name
tax_code_id
myob_account_code_id
billing_task_description
brand_type_id
job_type_id
billing_task_fee
  */


}
